<template>
  <div class="wrapper">
    <Menu />
    <Header title="Maça Bilet Al" hideMore />
    <div class="body-area pt70">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 tab-box">
            <div class="tab-header text-center bb-1" style="padding-left: 0; padding-right: 0">
              <div class="row no-gutters">
                <div
                  class="col-4 tab-select"
                  @click="activeTab = 0"
                  :class="activeTab == 0 ? 'active' : ''"
                >
                  <h1 class="fs-16">Maça Bilet Al</h1>
                </div>
                <div
                  class="col-4 tab-select"
                  @click="activeTab = 1"
                  :class="activeTab == 1 ? 'active' : ''"
                >
                  <h1 class="fs-16">Kombine</h1>
                </div>
                <div
                  class="col-4 tab-select"
                  @click="activeTab = 2"
                  :class="activeTab == 2 ? 'active' : ''"
                >
                  <h1 class="fs-16">Paketler</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 p-0" v-if="activeTab == 0">
            <h3 v-if="tickets.length == 0" style="text-align:center;padding-top:1em;">Şu anda satışa sunulmuş bilet bulunmamaktadır.</h3>  
            <div class="fixture-item" v-for="(item, index) in tickets" :key="index">
              <MatchVS :data="item" />
            </div>
          </div>

          <div class="col-12 p-0" v-if="activeTab == 1">
            <div class="fixture-item" v-for="(item, index) in combines" :key="index">
              <h3 style="text-align:center;padding-top:1em;">Şu anda kombine bilet satışımız bulunmamaktadır.</h3>
              <!--
              <img :src="item.image" class="w-100" alt />
              <div class="col-12 p-2">
                <p v-html="item.text"></p>
              </div>
              <button class="confirm-button" @click="$buy(item.ticketLink)">Hemen Al</button>
              -->

            </div>
          </div>

          <div class="col-12 p-0" v-if="activeTab == 2">
            <div class="row" style="margin: 0">
              <h3 v-if="packages.length == 0" style="text-align:center;padding-top:1em;display:block;width:100%">Şu anda satışa sunulmuş paket bilet bulunmamaktadır.</h3>  
            
              <div
                class="col-12 bg-5"
                style="height: 20px;padding: 0; display: flex; align-items: center; justify-content: center"
                v-if="packages.length != 0"
              >
                <span
                  style="width: 5px; height: 5px; border-radius: 2.5px; margin: 0px 2px; display: inline-block"
                  :style="'background-color: ' + (i == index ? '#fff' : '#ddd')"
                  v-for="(item, i) in packages"
                  :key="i"
                ></span>
              </div>
            </div>
            <carousel :perPage="1" @pageChange="pageChange" :paginationEnabled="false" v-if="packages.length != 0">
              <slide v-for="(item, index) in packages" :key="index">
                <div class="fixture-item">
                  <img :src="item.image" class="w-100" alt />
                  <div class="col-12 p-2">
                    <p v-html="item.text"></p>
                  </div>
                  <button class="confirm-button" @click="$buy(item.ticketLink)">Hemen Al</button>
                </div>
              </slide>
            </carousel>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import MatchVS from "@/components/MatchVS";
import axios from "axios";
export default {
  name: "Ticket",
  components: {
    Footer,
    Menu,
    Header,
    MatchVS
  },
  data() {
    return {
      tickets: [],
      packages: [],
      combines: [],
      activeTab: 0,
      index: 0
    };
  },
  methods: {
    pageChange(index) {
      this.index = index;
    }
  },
  beforeMount() {
    this.$store.state.loading = true;

    axios.post("biletler").then(res => {
      this.tickets = res.data.data.matches;
      this.packages = res.data.data.package;
      this.combines = res.data.data.combine;

      this.$store.state.loading = false;
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Ticket.vue